module.exports = __webpack_public_path__ + "img/tarj2-3.be2e334f.svg";